<template>
  <div class="user-header">
    <router-link :to="{ name: 'help' }"
                 class="user-header__link">Ajuda!</router-link>

    <router-link :to="{ name: 'settings-user-information' }">
      <sc-gravatar :email="user.email"
                   :alt="user.name"
                   class="user-header__image"
                   :size="30" />
    </router-link>

    <router-link
      :to="{ name: 'settings-user-information' }"
      class="user-header__link">
      <span>{{ user.email }}</span>
      <span> - ID: {{ user.is_production ? user.client_id : user.sandbox_id }}</span>
    </router-link>

    <a href @click.prevent="logout"
       class="user-header__link user-header__logout">Sair</a>
  </div>
</template>

<script>
  import { createNamespacedHelpers } from 'vuex';
  import { ScGravatar } from '@intelipost-js/secure-components';
  import {
      Auth,
      EventBus,
      Storage,
  } from '@intelipost-js/secure-providers';
  import { CognitoAuth } from 'amazon-cognito-auth-js';

  const { mapActions, mapGetters } = createNamespacedHelpers('auth');
  export default {
    name: 'sc-user',
    data() {
      return {
        user: Auth.getUser(),
      };
    },
    computed: {
      ...mapGetters([
        'getAuth',
      ]),
    },
    methods: {
      ...mapActions([
        'getLogout',
      ]),
      async logout() {
        const loginSSO = Storage.get('isLoginSSO', 'local');
        Storage.remove('isLoginSSO', 'local');
        if (loginSSO) {
          /**
           * remove sso data from storage before signout
           */
          Storage.remove('emailSSO', 'local');
          const cognitoData = Storage.get('cognito_data', 'local');
          Storage.remove('cognito_data', 'local');
          /**
           * signout from cognito and tms
           */
          const cognitoAuth = new CognitoAuth(cognitoData);
          cognitoAuth.signOut();
          this.getLogout();
          Auth.logout();
        } else {
          await this.getLogout();
          await Auth.logout();
          this.$router.push({
            name: 'login',
          });
        }
      },
    },
    created() {
      EventBus.$on('logout', this.logout);
      window.logout = Auth.logout;
    },
    components: {
      ScGravatar,
    },
  };
</script>

<style lang="scss" scoped>
  @import "~@intelipost-js/secure-ui/src/scss/variables"; //eslint-disable-line
  .user-header{
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }
  .user-header__link{
    font-size: $size-7;
    padding: 0 .5rem;
    color: $grey-darker;
    &:focus,
    &:hover {
      color: $primary;
    }
  }
  .user-header__image{
    border-radius: 50%;
    height: 30px;
  }
</style>


// WEBPACK FOOTER //
// src/components/sc-user/ScUser.vue